import View from './RetirementIncomeChartView';
import {
    connect,
} from 'react-redux';
import {
    retirementIncomeChartSelector,
} from './RetirementIncomeChartSelector';
import {
    setExpanded,
    setShowDetails,
    setIndex,
} from './RetirementIncomeChartActions';

const mapStateToProps = (state, ownProps) => {
    return retirementIncomeChartSelector(state, ownProps);
};

const mapDispatchToProps = (dispatch) => ({
    toggleExpanded: (expanded, clientId) => () => {
        dispatch(setExpanded(!expanded, clientId));
    },
    toggleShowDetails: (showDetails, clientId) => () => {
        dispatch(setShowDetails(!showDetails, clientId));
    },
    navigateYears: (index, offset, clientId) => () => {
        dispatch(setIndex(index + offset, clientId));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);